
import "D:/Projects/Aimer/AimerPay/src/components/PartnerManagementBanner/index.less?modules";
export default {"exitBtn": `exitBtn-p_mMrFtH`,"banner": `banner-VuMbMY0l`,"info": `info-RWnShGRT`,"merchantName": `merchantName-Y-1KxCLh`}
